import { render } from "./Compra.vue?vue&type=template&id=22b4ac4e&scoped=true"
import script from "./Compra.vue?vue&type=script&lang=js"
export * from "./Compra.vue?vue&type=script&lang=js"

import "./Compra.vue?vue&type=style&index=0&id=22b4ac4e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b4ac4e"]])

export default __exports__